import { render } from "./DownbarView.vue?vue&type=template&id=536f5bb8"
import script from "./DownbarView.vue?vue&type=script&lang=js"
export * from "./DownbarView.vue?vue&type=script&lang=js"

import "./DownbarView.vue?vue&type=style&index=0&id=536f5bb8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__